export class ServiceWorkerNotActiveError extends Error {}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {}
}
